export class PhoneType {
  private readonly data: {
    phoneTypeCode: string;
    phoneTypeDescription: string;
  };

  constructor(data: any) {
    this.data = data;
  }

  public get code(): string {
    return this.data.phoneTypeCode;
  }

  public get name(): string {
    return this.data.phoneTypeDescription;
  }
}
